const _excluded = ["size"];
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    for (r = 0; r < n.length; r++)
      (o = n[r]),
        -1 === t.indexOf(o) &&
          {}.propertyIsEnumerable.call(e, o) &&
          (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r)
    if ({}.hasOwnProperty.call(r, n)) {
      if (-1 !== e.indexOf(n)) continue;
      t[n] = r[n];
    }
  return t;
}
function _extends() {
  return (
    (_extends = Object.assign
      ? Object.assign.bind()
      : function (n) {
          for (var e = 1; e < arguments.length; e++) {
            var t = arguments[e];
            for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
          }
          return n;
        }),
    _extends.apply(null, arguments)
  );
}
import React from "react";
var Search24 = function Search24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    _extends(
      {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
      props,
    ),
    /*#__PURE__*/ React.createElement("path", {
      d: "m21.71 20.29-3.68-3.68a9.015 9.015 0 1 0-1.42 1.42l3.68 3.68c.19.186.445.29.71.29a1 1 0 0 0 1-1c0-.265-.104-.52-.29-.71zM11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14z",
      fill: "currentColor",
    }),
  );
};
var Search16 = function Search16(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    _extends(
      {
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
      props,
    ),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 7A5 5 0 1 1 2 7a5 5 0 0 1 10 0zm-.81 5.608a7 7 0 1 1 1.418-1.418l3.102 3.103c.186.189.29.443.29.709a.999.999 0 0 1-.998.998c-.266 0-.52-.104-.71-.29l-3.102-3.102zM14 5.238v-.472c.004.157.004.315 0 .472z",
      fill: "currentColor",
    }),
  );
};
const sizeMap = {
  24: Search24,
  16: Search16,
};
export function Search(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    console.warn(
      new Error(
        "The '".concat(
          size,
          "' size is not supported by the 'Search' icon. Please use one of the available sizes: '16', '24'.",
        ),
      ),
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
